import Vue from 'vue'
import VueMultianalytics from 'vue-multianalytics'
import Hotjar from './hotjar'
import router from '@/router/index'

if (process.env.APPLY_TRACKERS) {
    let gaConfig = {
        appName: 'PML Tenant', // Mandatory
        appVersion: '0.1', // Mandatory
        trackingId: process.env.GA_KEY, // Mandatory
        debug: false // Whether or not display console logs debugs (optional)
    }

    let mixpanelConfig = {
        token: process.env.MIXPANEL_KEY
    }

    let hotjarConfig = {
        hjid: process.env.HOTJAR_KEY,
        hjsv: process.env.HOTJAR_SV
    }

    VueMultianalytics.addCustomModule('hotjar', Hotjar)

    Vue.use(VueMultianalytics, {
        modules: {
            ga: gaConfig,
            hotjar: hotjarConfig,
            mixpanel: mixpanelConfig
        },
        routing: {
            vueRouter: router //  Pass the router instance to automatically sync with router (optional)
        }
    })
}



// WEBPACK FOOTER //
// ./src/analitycs/index.js